import React from "react";
import { IconButton } from "@chakra-ui/react";
import { Pause, Play } from "lucide-react";

type PlayPauseButtonProps = {
  isPlaying: boolean;
  onToggle: () => void;
};

export const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
  isPlaying,
  onToggle,
}) => (
  <IconButton
    variant="outline"
    _hover={{ bg: "rgb(72, 132, 175)" }}
    onClick={onToggle}
    mr={5}
    size="sm"
    borderRadius={"full"}
    bg={"newBlue.500"}
    icon={
      isPlaying ? (
        <Pause size={18} color="#fff" />
      ) : (
        <Play size={18} color="#fff" />
      )
    }
    aria-label="Toggle playback"
  />
);
